/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PecegepayBilletCoursefinpersonpaymentidPdf } from "../../clients/pecegePayBilletController/getApiV1PecegepayBilletCoursefinpersonpaymentidPdf.ts";

export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey = (
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams["courseFinPersonPaymentId"],
) =>
  [
    {
      url: "/api/v1/pecegepay/billet/:courseFinPersonPaymentId/pdf",
      params: { courseFinPersonPaymentId: courseFinPersonPaymentId },
    },
  ] as const;

export type GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey =
  ReturnType<typeof getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey>;

export function getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryOptions(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams["courseFinPersonPaymentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey(
    courseFinPersonPaymentId,
  );
  return queryOptions<
    GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500
    >,
    GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseFinPersonPaymentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PecegepayBilletCoursefinpersonpaymentidPdf(
        courseFinPersonPaymentId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna o arquivo PDF do boleto da parcela informada.
 * @summary Baixar PDF do boleto por parcela
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId/pdf}
 */
export function useGetApiV1PecegepayBilletCoursefinpersonpaymentidPdf<
  TData = GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
  TQueryData = GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey,
>(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams["courseFinPersonPaymentId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryKey(
      courseFinPersonPaymentId,
    );

  const query = useQuery(
    {
      ...getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryOptions(
        courseFinPersonPaymentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
